import authorizedAxios from "../../helpers/authorizedAxios";
import { showAlert, showToast } from "../../utils/helpers/ShowToast";
import { getReadableApiError } from "../../utils/helpers/apiError";

export const SET_PRODUCT_GROUPS = "SET_PRODUCT_GROUPS";
export const SET_PRODUCT_GROUPS_LOADING = "SET_PRODUCT_GROUPS_LOADING";
export const SET_PRODUCT_GROUPS_ERROR = "SET_PRODUCT_GROUPS_ERROR";

export const fetchProductGroups = (limit = 100, page = 1, search = "") => async (dispatch) => {
  dispatch({ type: SET_PRODUCT_GROUPS_LOADING, status: true });
  try {
    const response = await authorizedAxios.get("/product-groups", { params: { limit, page, search } });
    dispatch({ type: SET_PRODUCT_GROUPS, data: response?.data?.data || {} });
    return response?.data?.data;
  } catch (error) {
    dispatch({
      type: SET_PRODUCT_GROUPS_ERROR,
      error: getReadableApiError(error, "Gagal mengambil grup produk."),
    });
    return null;
  } finally {
    dispatch({ type: SET_PRODUCT_GROUPS_LOADING, status: false });
  }
};

export const addProductGroup = (data) => async (dispatch) => {
  dispatch({ type: SET_PRODUCT_GROUPS_LOADING, status: true });
  try {
    const response = await showToast(authorizedAxios.post("/product-groups", data), {
      loading: "Menyimpan produk dan varian...",
      success: "Produk dan varian berhasil ditambahkan",
      error: (error) => error?.response?.data?.message || "Produk gagal disimpan",
    });
    showAlert({ type: "success", message: "Produk dan varian berhasil ditambahkan!" });
    return { success: true, data: response?.data?.data };
  } catch (error) {
    dispatch({ type: SET_PRODUCT_GROUPS_ERROR, error: getReadableApiError(error, "Produk gagal disimpan.") });
    return { success: false, error };
  } finally {
    dispatch({ type: SET_PRODUCT_GROUPS_LOADING, status: false });
  }
};

export const updateProductGroup = (id, data) => async (dispatch) => {
  dispatch({ type: SET_PRODUCT_GROUPS_LOADING, status: true });
  try {
    const response = await showToast(authorizedAxios.put(`/product-groups/${id}`, data), {
      loading: "Memperbarui produk dan varian...",
      success: "Produk dan varian berhasil diperbarui",
      error: (error) => error?.response?.data?.message || "Produk gagal diperbarui",
    });
    showAlert({ type: "success", message: "Produk dan varian berhasil diperbarui!" });
    return { success: true, data: response?.data?.data };
  } catch (error) {
    dispatch({ type: SET_PRODUCT_GROUPS_ERROR, error: getReadableApiError(error, "Produk gagal diperbarui.") });
    return { success: false, error };
  } finally {
    dispatch({ type: SET_PRODUCT_GROUPS_LOADING, status: false });
  }
};

export const deleteProductGroup = (id) => async (dispatch) => {
  dispatch({ type: SET_PRODUCT_GROUPS_LOADING, status: true });
  try {
    await showToast(authorizedAxios.delete(`/product-groups/${id}`), {
      loading: "Menghapus grup produk...",
      success: "Grup produk berhasil dihapus",
      error: (error) => error?.response?.data?.message || "Grup produk gagal dihapus",
    });
    return { success: true };
  } catch (error) {
    dispatch({ type: SET_PRODUCT_GROUPS_ERROR, error: getReadableApiError(error, "Grup produk gagal dihapus.") });
    return { success: false, error };
  } finally {
    dispatch({ type: SET_PRODUCT_GROUPS_LOADING, status: false });
  }
};
